export default __webpack_public_path__ + "static/media/fotoKevlar.494dad81.jpg";